package com.milta.core.localization.translations.sq

import com.milta.core.localization.RouteCreationStrings

internal val RouteCreation = RouteCreationStrings(
    newRouteTitle = "Itinerar i ri",
    stepDeliveries = "Dërgesat",
    stepDrivers = "Shoferët",
    stepDistribution = "Shpërndarja",
    deliveriesSummary = "%1 dërgesa · %2 pako",
    deliveriesSummaryOne = "1 dërgesë · %1 pako",
    toFixCount = "%1 për t'u korrigjuar",
    allAddressesCorrect = "Të gjitha adresat janë të sakta",
    filterAll = "Të gjitha %1",
    filterToFix = "Për t'u korrigjuar %1",
    fixAddressesToContinue = "Korrigjoni %1 adresa për të vazhduar",
    fixOneAddressToContinue = "Korrigjoni 1 adresë për të vazhduar",
    continueWithDeliveries = "Vazhdo · %1 dërgesa",
    continueWithOneDelivery = "Vazhdo · 1 dërgesë",
    chooseAtLeastOneDriver = "Zgjidhni të paktën një shofer",
    reasonMissingHouseNumber = "Mungon numri i rrugës",
    reasonNotFound = "Adresa nuk u gjet",
    reasonUnverified = "Verifikimi nuk u krye, provoni përsëri",
    missingHouseNumberExample = "Mungon numri i rrugës. Shembull: %1",
    notFoundHelp = "Adresa nuk u gjet. Kontrolloni rrugën, numrin dhe kodin postar.",
    unverifiedHelp = "Adresa nuk mund të verifikohej për momentin. Provoni përsëri pas pak.",
    addToExistingHint = "Ato shtohen te %1 dërgesat që janë tashmë në listë.",
    importFileAction = "Importo një skedar",
    importFileHint = "Excel (.xlsx, .xls), CSV ose PDF",
    manualEntryAction = "Futje manuale",
    manualEntryHint = "Emri, adresa, telefoni, ora e fundit",
    addDeliveryTitle = "Shto një dërgesë",
    deleteDelivery = "Fshi dërgesën",
    addedFileAnalysing = "Po analizohet %1…",
    addedFileFailed = "Importi i %1 nuk u krye. Asnjë dërgesë nuk u shtua.",
    errorAddressesToFix = "Disa adresa nuk u vërtetuan: korrigjojini në listën „Për t'u korrigjuar”.",
    errorAddressesCheckRetry = "Verifikimi i adresave nuk përfundoi. Provoni përsëri pas pak.",
    errorBatchAlreadyDispatched = "Kjo shpërndarje u është dërguar tashmë shoferëve.",
    editDeliveryTitle = "Ndrysho dërgesën",
    zoneLabel = "Zona %1",
    workloadBalanced = "Kohët e punës janë të balancuara mes shoferëve",
    workloadGap = "Diferenca e kohës së punës mes shoferëve: %1",
    importAddedFromScan = "%1 dërgesa u shtuan nga skanimi",
    importAddedOneFromScan = "1 dërgesë u shtua nga skanimi",
    importAddedFromPdf = "%1 dërgesa u shtuan nga PDF-ja",
    importAddedOneFromPdf = "1 dërgesë u shtua nga PDF-ja",
    importAddedFromSpreadsheet = "%1 dërgesa u shtuan nga skedari Excel",
    importAddedOneFromSpreadsheet = "1 dërgesë u shtua nga skedari Excel",
    importAddedToFixSuffix = ", nga të cilat %1 për t'u korrigjuar",
    deliverySearchOpenAction = "Kërkoni një dërgesë",
    deliverySearchCount = "%1 nga %2",
    deliverySearchCountToFix = "%1 nga %2 për t'u korrigjuar",
    deliverySearchEmptyTitle = "Asnjë dërgesë nuk përputhet",
    deliverySearchEmptyToFixHint = "Asnjë dërgesë për t'u korrigjuar nuk përputhet. Provoni te „Të gjitha”.",
)
